// removed by extract-text-webpack-plugin
module.exports = {"stepImageComponent":"stepImageComponent__1Fid7","stepImageComponentMerchantPage":"stepImageComponentMerchantPage__1zfu1"};


//////////////////
// WEBPACK FOOTER
// ./routes/program-landing-page/components/bic-steps/steps-image/image-component/style.css
// module id = mXVj
// module chunks = 446